import CardButtons from "components/card-buttons";
import Markdown from "components/markdown";
import { Box, Grid, Text, images, useScrollSpy } from "designsystem";
import { IGatsbyImageData } from "gatsby-plugin-image";
import React from "react";
import HeaderImage from "./header-image";

interface HeaderProps {
  header: GatsbyTypes.HeaderNodeFragment;
}

/**
 * This component is used in the Content Page to render a header
 * @param param0
 */
const Header: React.FC<HeaderProps> = ({ header }) => {
  const id = "intro";
  const ref = useScrollSpy(id);

  const body = header.childContentfulHeaderBodyTextNode?.body;
  const image = {
    id: header.headerBackground?.id,
    image: header.headerBackground
      ?.gatsbyImageData as unknown as IGatsbyImageData,
    alt: String(header.headerBackground?.title)
  };

  const links = header.links;

  const elevation = header.imageShadow ? "high" : undefined;

  return (
    <>
      <Grid className="relative z-10" layout="content-sidebar" innerRef={ref}>
        <Box
          gridArea="content"
          direction="column"
          paddingTop="xl"
          paddingBottom="6xl"
        >
          <Grid layout="content-page-header" gap="gap">
            <Box direction="column" fontSize="l" justifyContent="center">
              <Text
                as="h1"
                size="3xl"
                weight="bold"
                marginTop="none"
                marginBottom="m"
                id={id}
                className="legacy-scroll-margin-top"
              >
                {header.title}
              </Text>
              {body && <Markdown content={body} />}

              <CardButtons links={links} marginTop="xl" />
            </Box>
          </Grid>
        </Box>
      </Grid>
      {image && (
        <HeaderImage
          src={
            image && image.image?.images.fallback
              ? image.image.images.fallback.src
              : images.headerBackground
          }
          alt={image.alt}
          elevation={elevation}
        />
      )}
    </>
  );
};
export default Header;
